import SatelliteIcon from '../asset/Images/satellite.png'
import LightIcon from '../asset/Images/light.png'
import DarkIcon from '../asset/Images/dark.png'
import StreetIcon from '../asset/Images/street.png'
import sensor from '../asset/Icon/station/water quality/waterquality.png'
import nutrient from '../asset/Icon/station/nutrient survey/nutrientsurvey.png'
import plankton from '../asset/Icon/station/plankton survey/planktonsurvey.png'
import sediment from '../asset/Icon/station/sediment quality/sedimentquality.png'
import heavyMetals from '../asset/Icon/station/heavy metals/hevy metals.png'
import petroleumHydrocarbon from '../asset/Icon/station/petroleum hydrocarbon/petroleum hydrocarbon.png'

export type Viewport = {
  longitude: number
  latitude: number
  zoom: number
  pitch: number
  bearing: number
}

export type CursorPositionProps = {
  latitude: number
  longitude: number
}

export type MenuItem = {
  name: string
  icon: string
  layerId: string
  latitude: number
  longitude: number
  parameter: string
  unitOfMeasurements: string
  waterDepth: number
  image: string
}

export type SubGroup = {
  name: string
  layerId: string
  menuItems: MenuItem[]
}

export type Group = {
  id: number
  name: string
  dataType?: string
  enableTimeSlider?: boolean
  subGroups?: SubGroup[]
  menuItems?: MenuItem[]
}

export type GeoJsonFeature = {
  type: 'Feature'
  geometry: {
    type: string
    coordinates: [number, number] | Array<[number, number]>
  }
  properties: {
    Name: string
    [key: string]: unknown
  }
}

export type GeoJsonFeatureCollection = {
  type: 'FeatureCollection'
  features: GeoJsonFeature[]
}

export type LayersData = {
  [subGroupId: string]: GeoJsonFeature[]
}

export type StationInfo = {
  selectedDataType: string
  selectedStation: string[]
  selectedParameters: string[]
  selectedArea: string
  [key: string]: unknown
}

export type PopupInfo = {
  [key: string]: unknown
}

export type LayerCollapseProps = {
  groups: Group[]
}

export type CustomPopupProps = {
  onClose: () => void
}

export enum DataType {
  WaterQuality = 'WaterQuality',
  SedimentQuality = 'SedimentQuality',
  PlanktonSurvey = 'PlanktonSurvey',
  NutrientSurveyResult = 'NutrientSurveyResult',
  PetroleumHydrocarbons = 'PetroleumHydrocarbons',
  HeavyMetals = 'HeavyMetals',
}

export interface MapStyle {
  src: string
  name: string
  mapStyle: string
}

export type MapStyleList = MapStyle[]

export const mapStyleList: MapStyleList = [
  {
    src: SatelliteIcon,
    name: 'Satellite',
    mapStyle: 'mapbox://styles/mapbox/satellite-v9?optimize=true',
  },
  {
    src: StreetIcon,
    name: 'Streets',
    mapStyle: 'mapbox://styles/mapbox/streets-v12?optimize=true',
  },
  {
    src: LightIcon,
    name: 'Light',
    mapStyle: 'mapbox://styles/mapbox/light-v11?optimize=true',
  },
  {
    src: DarkIcon,
    name: 'Dark',
    mapStyle: 'mapbox://styles/mapbox/dark-v11?optimize=true',
  },
]

export const imageStyle = {
  width: 25,
  height: 25,
  borderRadius: 5,
  border: '2px solid black',
  transition: 'opacity 0.3s ease',
}

export interface LegendData {
  id: number
  name: string
  type: number
  imageUrl: string | null
  color: string | null
  roles: string[]
}

export const legendData: LegendData[] = [
  {
    id: 0,
    name: 'Sensor',
    type: 0,
    imageUrl: sensor,
    color: null,
    roles: [
      'FishFarmer',
      'SFAAgency',
      'SFAGeneral',
      'Editor',
      'Administrator',
      'DHIAdmin',
      'SuperAdministrator',
    ],
  },
  {
    id: 1,
    name: 'Nutrient',
    type: 0,
    imageUrl: nutrient,
    color: null,
    roles: ['Editor', 'SFAAgency', 'SFAGeneral', 'Administrator', 'DHIAdmin', 'SuperAdministrator'],
  },
  {
    id: 2,
    name: 'Plankton',
    type: 0,
    imageUrl: plankton,
    color: null,
    roles: ['Editor', 'SFAGeneral', 'Administrator', 'DHIAdmin', 'SuperAdministrator'],
  },
  {
    id: 3,
    name: 'Sediment',
    type: 0,
    imageUrl: sediment,
    color: null,
    roles: ['Editor', 'SFAGeneral', 'Administrator', 'DHIAdmin', 'SuperAdministrator'],
  },
  {
    id: 4,
    name: 'Heavy Metals',
    type: 0,
    imageUrl: heavyMetals,
    color: null,
    roles: ['Editor', 'SFAGeneral', 'Administrator', 'DHIAdmin', 'SuperAdministrator'],
  },
  {
    id: 5,
    name: 'Ptroleum Hydrocarbon',
    type: 0,
    imageUrl: petroleumHydrocarbon,
    color: null,
    roles: ['Editor', 'SFAGeneral', 'Administrator', 'DHIAdmin', 'SuperAdministrator'],
  },
  {
    id: 6,
    name: 'Online',
    type: 2,
    imageUrl: null,
    color: 'green',
    roles: [
      'FishFarmer',
      'SFAAgency',
      'SFAGeneral',
      'Editor',
      'Administrator',
      'DHIAdmin',
      'SuperAdministrator',
    ],
  },
  {
    id: 7,
    name: 'Offline',
    type: 3,
    imageUrl: null,
    color: 'grey',
    roles: [
      'FishFarmer',
      'SFAAgency',
      'SFAGeneral',
      'Editor',
      'Administrator',
      'DHIAdmin',
      'SuperAdministrator',
    ],
  },
  {
    id: 8,
    name: 'Outside Threshold',
    type: 4,
    imageUrl: null,
    color: 'red',
    roles: [
      'FishFarmer',
      'SFAAgency',
      'SFAGeneral',
      'Editor',
      'Administrator',
      'DHIAdmin',
      'SuperAdministrator',
    ],
  },
  {
    id: 9,
    name: 'Selected Station',
    type: 5,
    imageUrl: null,
    color: 'yellow',
    roles: [
      'FishFarmer',
      'SFAAgency',
      'SFAGeneral',
      'Editor',
      'Administrator',
      'DHIAdmin',
      'SuperAdministrator',
    ],
  },
  {
    id: 10,
    name: 'Fish Farms',
    type: 1,
    imageUrl: null,
    color: '#5c8ab9',
    roles: [
      'FishFarmer',
      'SFAAgency',
      'SFAGeneral',
      'Editor',
      'Administrator',
      'DHIAdmin',
      'SuperAdministrator',
    ],
  },
]
